import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  text = 'Carregando...' 
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-mystical">
      <div className="relative">
        {/* Spinner principal */}
        <div className={`${sizeClasses[size]} border-4 border-mystical-200 border-t-mystical-500 rounded-full animate-spin`}></div>
        
        {/* Efeito de brilho místico */}
        <div className={`absolute inset-0 ${sizeClasses[size]} border-4 border-transparent border-t-gold-400 rounded-full animate-spin mystical-glow`} 
             style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
      </div>
      
      {text && (
        <p className="mt-4 text-white font-mystical text-lg animate-pulse">
          {text}
        </p>
      )}
      
      {/* Partículas flutuantes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-mystical-400 rounded-full animate-ping" 
             style={{ animationDelay: '0s' }}></div>
        <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-gold-400 rounded-full animate-ping" 
             style={{ animationDelay: '0.5s' }}></div>
        <div className="absolute bottom-1/3 left-1/3 w-1.5 h-1.5 bg-mystical-300 rounded-full animate-ping" 
             style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/4 right-1/3 w-1 h-1 bg-gold-300 rounded-full animate-ping" 
             style={{ animationDelay: '1.5s' }}></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;